// src/hidden-instruction.ts
var e = "cio-app-note:";
function t(t, n) {
	let r = n.trim().replace(/--(?=!?>)/g, "- -");
	return r === "" ? t : `${t.trimEnd()}\n\n<!-- ${e} ${r} -->`;
}
var n = RegExp(`\\s*<!-- ${e}[\\s\\S]*?-->\\s*$`);
function r(e) {
	return n.test(e);
}
function i(e) {
	return e.replace(n, "");
}
export { r as hasHiddenInstruction, i as stripHiddenInstruction, t as withHiddenInstruction };
